import React from 'react'
import { PrintButtonProps } from './PrintButton.types'
import styles from './PrintButton.module.scss'
import cl from 'classnames'
import { Button } from '../Button'
import { IconPrint } from 'assets'

const PrintButtonComponent = (props: PrintButtonProps) => {
  const {
    preset,
    title,
    className,
    ...rest
  } = props

  return (
    <Button
      preset={preset || 'icon'}
      title={title || 'print'}
      className={cl(styles.container, className)}
      disabled
      {...rest}
    >
      <IconPrint fill={styles.primary} />
    </Button>
  )
}

const PrintButton = PrintButtonComponent
export { PrintButton }
